import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { apiRequest } from "../../Lib/Utils/ApiRequest";
import { IApiResponse } from "../../Orchestrator/Types/Index";
import { ILoyaltyProgramResponse } from "../../Orchestrator/Types/Interface/ILoyaltyProgram";

export async function getLoyaltyProgram(
  userId: number
): Promise<IApiResponse<ILoyaltyProgramResponse>> {
  const ENDPOINTS = await getEndpoints();
  const endpoint = ENDPOINTS.getLoyaltyProgram(userId);

  return await apiRequest<ILoyaltyProgramResponse>(endpoint, "GET");
}
